import {connect} from "react-redux";
import {ApiKeys, DispatchProps, InnerProps, StateProps} from "../components/ApiKeys";
import {RootState, ThunkDispatch} from "../types";
import {doCreateApiKey, doDeleteApiKey, doGetApiKeys} from "../actions/thunks/users";
import {cleanApiKey} from "../actions/users";
import {userIsAllowed} from "../utils/commons";
import {Routes} from "../utils/router";

function mapStateToProps({user}: RootState): StateProps {
    return {
        credentials: user.credentials,
        generatedCredential: user.generatedCredential,
        creating: user.creatingCredential,
        isAllowed: userIsAllowed(user.credits),
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch): DispatchProps {
    return {
        onDeleteCredential: (id) => dispatch(doDeleteApiKey(id)),
        onCreateCredential: () => dispatch(doCreateApiKey()),
        onGetCredentials: () => dispatch(doGetApiKeys()),
        onCleanCredential: () => dispatch(cleanApiKey()),
        onGoToStore: () => window.open(Routes.STORE, "_blank"),
    };
}

export default connect<StateProps, DispatchProps, InnerProps, RootState>(mapStateToProps, mapDispatchToProps)(ApiKeys);
